import { render } from "./LayoutView.vue?vue&type=template&id=2d8367c1&scoped=true"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"

import "./LayoutView.vue?vue&type=style&index=0&id=2d8367c1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8367c1"]])

export default __exports__